<script>
import { convertCurrency } from '~/assets/js/methods';
import OrderbumpsCheckbox from './OrderbumpsCheckbox.vue';

export default {
    name: "Orderbumps",
    props: ["orderBumpData"],
    setup() {
        return {
            convertCurrency
        };
    },
    computed: {
        getCart() {
            return this.$store.getters["getCart"];
        }
    },
    watch: {
        orderbump_check: {
            handler(e) {

                this.$nextTick(() => {
                    this.managerOrderbump();
                });
            }
        },
        getCart: {
            handler(e) {
                let checkItemChecked = e.find(item => item.cartvar === `${this.orderbump_var_selected.hash}_2`);
                if (typeof checkItemChecked === 'undefined') {
                    this.orderbump_check = false;
                }
            }
        }
    },
    methods: {
        managerOrderbump() {
            let objectItemOrderbump = {
                cartvar: `${this.orderbump_var_selected.hash}_2`,
                id: this.orderbump_data.id,
                hash: this.orderbump_data.product_hash,
                variation_id: this.orderbump_var_selected.id,
                variation_hash: this.orderbump_var_selected.hash,
                shopify_product_id: this.orderbump_var_selected.shopify_product_id,
                shopify_variation_id: this.orderbump_var_selected.shopify_variant_id,
                sku: this.orderbump_var_selected.sku,
                product_hash: this.orderbump_data.product_hash,
                product_id: this.orderbump_data.product_id,
                title: this.orderbump_data.product_title,
                variation_title: this.orderbump_var_selected.title ?? this.orderbump_data.product_title,
                cover: this.orderbump_var_selected?.url || this.orderbump_var_selected?.cover,
                price: parseInt(this.orderbump_data.price_promotional),
                quantity: 1,
                operation_type: 2
            };
    
            if (this.orderbump_check === true) {
                this.$store.commit("setCartItem", objectItemOrderbump);
                this.$emit('check', objectItemOrderbump);
            } else {
                this.$store.commit("removeCartItem", objectItemOrderbump);
                this.$emit('check', false);
            }
        },
        changeVar(currentVar, index) {

            this.orderbump_var[index] = currentVar;

            let mountFullVar = this.orderbump_var.join('').replace(/\s/g, '').replace(/[()]/g, '').replace(/[^A-Z0-9]+/ig, '');

            let combinations = Object.values(this.orderBumpData.combinations);

            let title = '';

            const found = combinations.find((element) => {
                title = element.title.replace(/[^A-Z0-9]+/ig, '').replace(/[()]/g, '');
                if (title == mountFullVar) {
                    return element;
                }
            });

            if (found) {
                this.orderbump_var_selected = found;
            }

            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        changeSizes(currentVar) {
            this.orderbump_var = JSON.parse(currentVar)[0];

            if (this.orderBumpData.colors.length > 0) {
                this.orderbump_colors = JSON.parse(currentVar);
            }
        }
    },
    data() {
        return {
            orderbump_check: false,
            orderbump_data: {},
            orderbump_var: [],
            orderbump_var_selected: '',
            orderbump_colors: "",
            orderbump_source_product: ""
        };
    },
    beforeMount() {
        this.getCart.forEach((v, k) => {
            if(this.orderBumpData && this.orderBumpData.variations && typeof this.orderBumpData.variations === 'object') {
                this.orderBumpData.variations = Object.values(this.orderBumpData.variations)
            }
            if (typeof this.orderBumpData !== 'undefined' && typeof this.orderBumpData.variations !== 'undefined' && this.orderBumpData.variations.length > 0) {
                let checkItem = this.orderBumpData.variations.find(item => `${item.hash}_2` === v.cartvar);

                if (typeof checkItem !== "undefined") {
                    this.orderbump_check = true;
                    this.orderbump_var_selected = checkItem;
                }
            }

            if (typeof this.orderBumpData.product_id !== 'undefined' && this.orderBumpData.product_id === v.id) {
                this.orderbump_source_product = v;
            }
        });

        if (typeof this.orderBumpData.options !== 'undefined' && this.orderBumpData.options.length > 0) {
            this.orderBumpData.options.forEach((v, k) => {
                this.orderbump_var[k] = undefined;
            });

            this.orderbump_data.options = this.orderBumpData.options.map((option) => {
                if (typeof option?.values === 'string') {
                    option.values = JSON.parse(option.values).filter(value => (value?.status == 1) || !value?.status);
                }

                return option;
            });
        }

        if (typeof this.orderBumpData.variations !== 'undefined' && this.orderBumpData.variations.length > 0) {

            this.orderbump_data.variations = this.orderBumpData.variations.map((variation) => {
                variation.descript = '';

                ['option1', 'option2', 'option3'].forEach((attr) => {
                    if (variation.hasOwnProperty(attr)) {
                        if (variation[attr] !== null && variation[attr] !== 'Default Title' && variation[attr] !== '' && typeof variation[attr] !== 'undefined') {
                            variation.descript += ' ' + variation[attr];
                            console.log(variation[attr]);
                        }
                    }
                });

                if (variation.descript.length == 0) {
                    variation.descript = variation.title;
                }

                return variation;
            })
                .filter((variation) => typeof variation.descript !== 'undefined');

            let variation_combinations = Object.values(this.orderBumpData.combinations);
            if (variation_combinations.length != this.orderBumpData.variations.length) {
                this.orderBumpData.variations = this.orderBumpData.variations.filter((variation) => {
                    return variation_combinations.find((v_combination) => {
                        return v_combination.title == variation.title;
                    });
                });
            }
        }
    },
    mounted() {
        this.orderbump_data = this.orderBumpData.orderbump;
        this.$nextTick(() => {
            if (this.orderbump_var_selected === '') {
                if (typeof this.orderBumpData.variations !== 'undefined') {
                    this.orderbump_var_selected = this.orderBumpData.variations[0];
                }
            }

            if (this.orderbump_var_selected && this.orderBumpData.options) {
                this.orderBumpData.options.forEach((option, index) => {
                    this.orderbump_var[index] = this.orderbump_var_selected[`option${index + 1}`];
                });
            }
        });
    },
    components: { OrderbumpsCheckbox }
}
</script>

<template>
    <div>
        <div class="orderbump js-orderbump" :class="{ 'selected': orderbump_check }">
            <div class="orderbump_product">
                <div>
                    <img :src="orderbump_var_selected?.url || orderbump_var_selected?.cover" loading="lazy" class="orderbump_product-image">
                </div>

                <div class="orderbump_product-details">
                    <div class="orderbump_product-name">
                        <span class="orderbump_product-title">{{ orderBumpData.orderbump.product_title }}</span>
                        <span class="orderbump_product-selected-title">{{ orderbump_var_selected.title }}</span>
                    </div>

                    <div class="orderbump_holder-price">
                        <span class="orderbump_old-price mr5">R$
                            {{ convertCurrency(orderBumpData.orderbump.price / 100) }}</span>
                        <span class="orderbump_price bold"> {{ (orderBumpData.orderbump.price_promotional <= 0) ? 'Grátis' :
                            `R$ ${convertCurrency(orderBumpData.orderbump.price_promotional / 100)}` }}</span>
                    </div>

                    <div class="js-orderbump_product-options"
                        v-if="(typeof orderBumpData.options !== 'undefined' && orderBumpData.options.length > 0 && orderBumpData.options[0].name !== 'Title') && (orderBumpData.variations[0]?.option2 !== null || orderBumpData.variations[0]?.option3 != null)">
                        <div class="mt10" v-for="(item, index) in orderBumpData.options" :key="`options_${index}`">
                            <label class="block mb2 text-left bold f12"><span>{{ item.name }}</span></label>
                            <div class="holder-selectskin" v-if="!orderbump_check">
                                <div class="select-skin">
                                    <select name="gridOptions" @change="changeVar($event.target.value, index)"
                                        class="input-small js-select-variation selectskin" style="width: 100%; opacity: 0;">
                                        <option :key="`option_select`" value="">Selecione</option>
                                        <option v-for="(itemOption, indexOption) in item.values"
                                                :key="`option_${indexOption}`" :value="itemOption">
                                            {{ itemOption }}
                                        </option>
                                    </select>
                                    <div class="select-skin-mask">
                                        <div class="select-skin-text-clip">
                                            <div class="select-skin-text">
                                                {{ orderbump_var[index] ?? "Selecione" }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="js-orderbump_product-options"
                    v-else-if="(typeof orderBumpData.variations !== 'undefined' && orderBumpData.variations.length > 0 && orderBumpData.variations[0].option1 !== 'Default Title')">
                        <div class="mt10">
                            <div v-if="!orderbump_check">

                            <label class="block mb2 text-left bold f12"><span>Selecione</span></label>
                            <div class="holder-selectskin" >
                                <div class="select-skin">
                                    <select name="gridOptions" @change="changeVar($event.target.value, 0)"
                                        class="input-small js-select-variation selectskin" style="width: 100%; opacity: 0;">
                                        <option v-for="(item, index) in orderBumpData.variations"
                                            :key="`variation_${index}`" :value="item.title">
                                            {{ item.descript }}
                                        </option>
                                    </select>
                                    <div class="select-skin-mask">
                                        <div class="select-skin-text-clip">
                                            <div class="select-skin-text">
                                                {{ orderbump_var_selected.option1 }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </div>

            <div v-if="orderbump_check && orderBumpData.orderbump.price_promotional > 0" style="margin-bottom: 10px;">
                Parabéns! Você ganhou R$ {{ convertCurrency(parseInt(orderBumpData.orderbump.price -
                    orderBumpData.orderbump.price_promotional) / 100) }} em desconto 👏
            </div>

            <div class="orderbump_title">
                {{ orderBumpData.orderbump.title }}
            </div>

            <div class="orderbump_message">
                {{ orderBumpData.orderbump.description }}
            </div>

            <div class="orderbump_button" v-if="orderbump_var_selected"
                @click="orderbump_check = !orderbump_check; orderbump_data = orderBumpData.orderbump; ((orderbump_var_selected === '') ? orderbump_var_selected = item.variations[0] : '');">
                <div class="orderbump_button-checkbox mr10">
                    <img src="/img/checked.png" width="16" height="16" v-if="orderbump_check">
                    <img src="/img/unchecked.png" width="16" height="16" v-if="!orderbump_check">
                </div>
                <div class="orderbump_button-cta medium white " style="text-transform: uppercase;">
                    {{ (!orderbump_check) ? orderBumpData.orderbump.call_to_action : 'Adicionado!' }}
                </div>
            </div>

            <div class="orderbump_disclaimer black-60" v-if="true">
                <div class="orderbump_disclaimer-title bold f10">
                    Porque você está comprando:
                </div>
                <div class="orderbump_disclaimer-message mt5 f12">
                    {{ orderbump_source_product.title }}
                </div>
            </div>
            <div class="overlay-spinner overlay-spinner-account hide">
                <div class="spinner spinner-grey"></div>
                <!-- /.spinner spinner-grey -->
            </div>
    </div>
</div>
</template>
